import {
  Table,
  TableColumn,
  TableGetDataResponse,
} from '@ansys-internal/awf-angular/contributions';
import { AWCFilter } from '@ansys-internal/awc-angular/filters';
import { ConceptService } from '../../../shared/services/concept.service';
import { ActiveConceptState } from '../../../state/lib/active-concept.state';
import { State } from '@ansys-internal/awf-angular/store';
import { SelectedDriveCycleState } from '../../../state/lib/selected-drive-cycle.state';
import { DriveCycleTableType } from '../../../shared/types/drive-cycle-table.type';
import { AWFTable } from '@ansys-internal/awf-angular/core';
import { DriveCycleTableNameColumn } from './drive-cycle-table-name.column';
import { DriveCycleTableMenuColumn } from './menu/drive-cycle-table-menu.column';
import { ContributionsEnum } from '../../contributions.enum';
import { DriveCycleTableSelectedColumn } from './drive-cycle-table-selected.column';
import { DriveCycleTableNumberOfPointsColumn } from './drive-cycle-table-number-of-points.column';
import { DriveCycleTableTotalDistanceColumn } from './drive-cycle-table-total-distance.column';
import { DriveCycleTableTotalTimeColumn } from './drive-cycle-table-total-time.column';

@AWFTable({
  id: ContributionsEnum.DRIVE_CYCLE_TABLE_ID,
  columns: [
    DriveCycleTableSelectedColumn,
    DriveCycleTableNameColumn,
    DriveCycleTableNumberOfPointsColumn,
    DriveCycleTableTotalDistanceColumn,
    DriveCycleTableMenuColumn,
    DriveCycleTableTotalTimeColumn,
  ],
})
export class DriveCycleTable implements Table {
  id = ContributionsEnum.DRIVE_CYCLE_TABLE_ID;
  columns: TableColumn[] = [];
  type: string = ContributionsEnum.DRIVE_CYCLE_TABLE_ID;

  constructor(private conceptService: ConceptService, private state: State) {}

  async getData(
    pageNumber: number,
    filters: AWCFilter[] | undefined,
    fallbackData: any,
    searchValue: string | undefined
  ): Promise<TableGetDataResponse> {
    const concept = this.state.value(ActiveConceptState);
    const selectedDriveCycle = this.state.value(SelectedDriveCycleState);
    if (!concept) {
      return Promise.resolve({ data: [], total: 0 });
    }

    const driveCycles = await this.conceptService.getConceptDriveCycles(
      concept,
      false
    );

    const driveCycleTableData: DriveCycleTableType[] = driveCycles.map(
      (driveCycle) => {
        return {
          id: driveCycle.id,
          name: driveCycle.name,
          numberOfPoints: driveCycle.number_of_points,
          totalTime: driveCycle.total_time,
          totalDistance: driveCycle.total_distance,
          selected: driveCycle.id === selectedDriveCycle,
        };
      }
    ) as DriveCycleTableType[];

    return Promise.resolve({
      data: driveCycleTableData,
      total: driveCycleTableData['length'],
    });
  }

  getId(data: DriveCycleTableType): string {
    return data.id;
  }
}
